import React from 'react';

import styles from './index.module.css';
import concatStyles from 'helpers/concatStyles';

type PopupAction = {
  label: string;
  callback: Function;
};

interface Props {
  title: string;
  message: string;
  actions: PopupAction[];
  messageClassname?: string;
  messageComponent?: () => React.ReactNode;
}

const Popup: React.FC<Props> = ({
  title,
  message,
  actions,
  messageClassname,
  messageComponent,
}) => {
  return (
    <div className={styles.container}>
      <div>
        <h1 className={styles.title}>{title}</h1>
        {messageComponent ? (
          messageComponent()
        ) : (
          <p
            className={concatStyles([
              styles.message,
              ...(messageClassname ? [messageClassname] : []),
            ])}
          >
            {message}
          </p>
        )}
      </div>
      <div className={styles.actionContainer}>
        {actions.map(({label, callback}) => (
          <div className={styles.button} onClick={() => callback()} key={label}>
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Popup;
